// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               unknown
// source: qonto/registration/api/customer/firstparty/v1/customer.proto

/* oxlint-disable */
import { ApiTimestamp } from "../../../../../../google/protobuf/timestamp";

/** Message for customer information. */
export interface ApiCustomer {
  /** Timestamp when the contract was signed. */
  readonly contractSignedAt?:
    | Date
    | null
    | undefined;
  /** Nature of operations. */
  readonly natureOfOperations: readonly string[];
}

export const ApiCustomer: MessageFns<ApiCustomer> = {
  fromJSON(object: any): ApiCustomer {
    return {
      contractSignedAt: isSet(object.contractSignedAt) ? fromJsonTimestamp(object.contractSignedAt) : null,
      natureOfOperations: globalThis.Array.isArray(object?.natureOfOperations)
        ? object.natureOfOperations.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: ApiCustomer): unknown {
    const obj: any = {};
    if (message.contractSignedAt !== undefined && message.contractSignedAt !== null) {
      obj.contractSignedAt = message.contractSignedAt.toISOString();
    }
    if (message.natureOfOperations?.length) {
      obj.natureOfOperations = message.natureOfOperations;
    }
    return obj;
  },
};

function fromTimestamp(t: ApiTimestamp): Date {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(ApiTimestamp.fromJSON(o));
  }
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
